/** @jsx jsx */

import { jsx } from '@emotion/core';

export const Certificate_1_SVG = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 2084 1471.6"
      xmlSpace="preserve"
    >
      <g id="Change_colour">
        <g>
          <path
            style={{
              fill: '#00CBC3',
            }}
            d="M1236.1,836.2v-14.5v-19.4c0-5.8-4.7-10.5-10.5-10.5H859.2c-5.8,0-10.5,4.7-10.5,10.5v17.1v14.4    C535.6,854.3,245.2,928.2-3,1042.3l1,431.2h2088.3l1.5-415.8C1841.1,939,1550.5,860.6,1236.1,836.2z"
          />
        </g>
      </g>
      <g id="Foreground">
        <g>
          <path
            style={{
              opacity: 0.9,
              fill: '#FFFFFF',
            }}
            d="M1236.1,836.2v19c0,5.8-4.7,10.5-10.5,10.5H859.2c-5.8,0-10.5-4.7-10.5-10.5v-21.4    C535.6,854.3,245.2,928.2-3,1042.3l1,431.2h2088.3l1.5-415.8C1841.1,939,1550.5,860.6,1236.1,836.2z M1344,1191.3l-53.6,61.1    c-0.1,0.1-0.1,0.1-0.2,0.1c0.1,0,0.1,0,0.1,0c19.3,13,44.9,37.5,52.3,44.7c0.9,0.9,0.4,2.4-0.8,2.6c-37,5.8-74,7.7-99.1,8.1    l-0.1,0c0.3,13.5-0.1,20.9-0.2,23.3l-0.1,1.3c-0.4,1.9-4,3.9-12.3,6.2c-17.3,4.8-52.2,7.1-77.3,7.9l4.8,18.8    c0.6,2.4-1.1,4.8-3.6,4.9l-19.9,1.3c-2,0.1-3.6,1.7-3.7,3.7l-1.3,19.9c-0.2,2.5-2.5,4.2-4.9,3.6l-19.3-4.9    c-1.9-0.5-3.9,0.5-4.7,2.4l-7.4,18.6c-0.9,2.3-3.7,3.2-5.8,1.9l-16.9-10.7c-1.7-1.1-3.9-0.7-5.2,0.8l-12.7,15.4    c-1.6,1.9-4.5,1.9-6.1,0l-12.7-15.4c-1.3-1.5-3.5-1.9-5.2-0.8l-16.9,10.7c-2.1,1.3-4.9,0.4-5.8-1.9l-7.4-18.6    c-0.7-1.9-2.7-2.9-4.7-2.4l-19.3,4.9c-2.4,0.6-4.8-1.1-4.9-3.6l-1.3-19.9c-0.1-2-1.7-3.6-3.7-3.7l-19.9-1.3    c-2.5-0.2-4.2-2.5-3.6-4.9l4.9-19c-24.7-0.7-57.5-3-74.9-7.8c-8.3-2.3-11.9-4.3-12.3-6.2l-0.1-1.3c-0.1-2.4-0.5-9.8-0.2-23.3    l-0.1,0c-25.2-0.4-62.3-2.4-99.4-8.2c-1.1-0.2-1.5-1.5-0.7-2.2c7.1-6.9,32.9-31.7,52.4-44.9c0.1-0.1,0.2-0.1,0.4-0.1    c0,0,0.1,0,0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2-0.1-0.3-0.1l-53.7-61.3c-0.7-0.8,0-2,1-1.9c77.4,10.8,139.3,8.1,164.3,7.2    c11.6-0.4,15.5,0.8,15,2.6l0.1,0c-0.3,2-2.7,20.9-2.5,36.4c1.6,0.1,6.6,0.3,11.2,0.6c0-0.4,0-0.8-0.1-1.2l-4.9-19.3    c-0.6-2.4,1.1-4.8,3.6-4.9l19.9-1.3c2-0.1,3.6-1.7,3.7-3.7l1.3-19.9c0.2-2.5,2.5-4.2,4.9-3.6l19.3,4.9c1.9,0.5,3.9-0.5,4.7-2.4    l7.4-18.6c0.9-2.3,3.7-3.2,5.8-1.9l16.9,10.7c1.7,1.1,3.9,0.7,5.2-0.8l12.7-15.4c1.6-1.9,4.5-1.9,6.1,0l12.7,15.4    c1.3,1.5,3.5,1.9,5.2,0.8l16.9-10.7c2.1-1.3,4.9-0.4,5.8,1.9l7.4,18.6c0.7,1.9,2.7,2.9,4.7,2.4l19.3-4.9c2.4-0.6,4.8,1.1,4.9,3.6    l1.3,19.9c0.1,2,1.7,3.6,3.7,3.7l19.9,1.3c2.5,0.2,4.2,2.5,3.6,4.9l-4.9,19.3c-0.1,0.3-0.1,0.6-0.1,1c6.1-0.1,11.6-0.3,13.7-0.4    c0.2-15.5-2.2-34.4-2.5-36.4l0.1,0c-0.5-1.8,3.4-3,15-2.6c25,0.9,86.8,3.6,164.1-7.2C1344,1189.1,1344.7,1190.4,1344,1191.3z"
          />
        </g>
        <g
          style={{
            opacity: 1 || 0.05,
          }}
        >
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1225.6,791.8H859.2c-5.8,0-10.5,4.7-10.5,10.5v17.1v14.4v21.4c0,5.8,4.7,10.5,10.5,10.5h366.4    c5.8,0,10.5-4.7,10.5-10.5v-19v-14.5v-19.4C1236.1,796.5,1231.4,791.8,1225.6,791.8z"
          />
        </g>
        <g>
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M948.6,828.8c-1.2,1.1-3,1.7-5.4,1.7h-4v8.7h-2.7v-20.7h6.7c2.3,0,4.1,0.6,5.3,1.7    c1.2,1.1,1.8,2.6,1.8,4.4C950.4,826.3,949.8,827.7,948.6,828.8z M946.6,827.3c0.7-0.7,1.1-1.6,1.1-2.8c0-2.6-1.5-3.8-4.4-3.8h-4    v7.6h4C944.7,828.3,945.8,828,946.6,827.3z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M965.7,839.2l-4.9-8.5h-3.3v8.5h-2.7v-20.7h6.7c1.6,0,2.9,0.3,4,0.8c1.1,0.5,1.9,1.3,2.4,2.2    c0.5,0.9,0.8,2,0.8,3.1c0,1.4-0.4,2.7-1.2,3.8c-0.8,1.1-2.1,1.8-3.7,2.2l5.2,8.7H965.7z M957.5,828.6h4c1.5,0,2.6-0.4,3.3-1.1    c0.7-0.7,1.1-1.7,1.1-2.9c0-1.2-0.4-2.2-1.1-2.9c-0.7-0.7-1.8-1-3.3-1h-4V828.6z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M976.6,820.7v6.9h7.6v2.2h-7.6v7.1h8.4v2.2h-11.2v-20.8h11.2v2.2H976.6z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M993.1,838.7c-1.1-0.5-1.9-1.2-2.5-2c-0.6-0.9-0.9-1.9-1-3h2.9c0.1,1,0.5,1.8,1.2,2.5    c0.7,0.7,1.7,1,3.1,1c1.3,0,2.3-0.3,3-1c0.7-0.6,1.1-1.5,1.1-2.5c0-0.8-0.2-1.4-0.7-1.9c-0.4-0.5-1-0.9-1.6-1.1    c-0.7-0.3-1.5-0.5-2.6-0.8c-1.4-0.4-2.5-0.7-3.3-1.1c-0.8-0.4-1.5-0.9-2.1-1.7c-0.6-0.8-0.9-1.8-0.9-3.1c0-1.1,0.3-2.1,0.9-3    c0.6-0.9,1.4-1.5,2.4-2c1-0.5,2.2-0.7,3.6-0.7c1.9,0,3.5,0.5,4.8,1.5c1.2,1,1.9,2.3,2.1,3.9h-3c-0.1-0.8-0.5-1.5-1.2-2.1    c-0.7-0.6-1.7-0.9-2.9-0.9c-1.1,0-2.1,0.3-2.8,0.9c-0.7,0.6-1.1,1.4-1.1,2.5c0,0.8,0.2,1.4,0.6,1.8c0.4,0.5,1,0.8,1.6,1.1    c0.6,0.2,1.5,0.5,2.6,0.8c1.4,0.4,2.5,0.7,3.3,1.1s1.5,0.9,2.1,1.7c0.6,0.8,0.9,1.8,0.9,3.1c0,1-0.3,2-0.8,2.9    c-0.5,0.9-1.3,1.6-2.4,2.2c-1.1,0.6-2.3,0.8-3.7,0.8C995.4,839.4,994.2,839.2,993.1,838.7z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1011.4,820.7v6.9h7.6v2.2h-7.6v7.1h8.4v2.2h-11.2v-20.8h11.2v2.2H1011.4z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1041.3,839.2h-2.7l-10.9-16.5v16.5h-2.7v-20.8h2.7l10.9,16.5v-16.5h2.7V839.2z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1059.7,818.5v2.2h-5.7v18.5h-2.7v-18.5h-5.7v-2.2H1059.7z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1066.8,820.7v6.9h7.6v2.2h-7.6v7.1h8.4v2.2h-11.2v-20.8h11.2v2.2H1066.8z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1092.7,819.7c1.7,0.8,2.9,2,3.8,3.6c0.9,1.6,1.3,3.4,1.3,5.5c0,2.1-0.4,4-1.3,5.5    c-0.9,1.6-2.2,2.7-3.8,3.6c-1.7,0.8-3.6,1.2-5.9,1.2h-6.5v-20.7h6.5C1089.1,818.5,1091.1,818.9,1092.7,819.7z M1093,834.8    c1.4-1.4,2.1-3.4,2.1-6c0-2.6-0.7-4.6-2.1-6c-1.4-1.4-3.5-2.2-6.1-2.2h-3.7V837h3.7C1089.5,837,1091.6,836.3,1093,834.8z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1124.2,818.5v2.2h-5.7v18.5h-2.7v-18.5h-5.7v-2.2H1124.2z"
          />
          <path
            style={{
              fill: '#FFFFFF',
            }}
            d="M1132.7,838.1c-1.6-0.9-2.8-2.2-3.8-3.8c-0.9-1.6-1.4-3.4-1.4-5.5c0-2,0.5-3.8,1.4-5.5    c0.9-1.6,2.2-2.9,3.8-3.8c1.6-0.9,3.3-1.4,5.3-1.4c1.9,0,3.7,0.5,5.3,1.4c1.6,0.9,2.8,2.2,3.7,3.8c0.9,1.6,1.4,3.4,1.4,5.5    s-0.5,3.9-1.4,5.5c-0.9,1.6-2.2,2.9-3.7,3.8c-1.6,0.9-3.4,1.4-5.3,1.4C1136.1,839.4,1134.3,839,1132.7,838.1z M1141.9,836.1    c1.2-0.7,2.1-1.6,2.7-2.9c0.7-1.2,1-2.7,1-4.3c0-1.7-0.3-3.1-1-4.4c-0.7-1.2-1.6-2.2-2.7-2.9c-1.2-0.7-2.5-1-3.9-1    c-1.5,0-2.8,0.3-3.9,1c-1.2,0.7-2.1,1.6-2.7,2.9c-0.7,1.2-1,2.7-1,4.4c0,1.6,0.3,3.1,1,4.3c0.7,1.2,1.6,2.2,2.7,2.9    c1.2,0.7,2.5,1,3.9,1C1139.4,837.1,1140.8,836.7,1141.9,836.1z"
          />
        </g>
        <path
          style={{
            fill: 'none',
          }}
          d="M1242.8,1307.9c25.1-0.4,62.1-2.4,99.1-8.1c1.2-0.2,1.7-1.7,0.8-2.6c-7.5-7.3-33-31.7-52.3-44.7   c0,0-0.1,0-0.1,0c0.1,0,0.2-0.1,0.2-0.1l53.6-61.1c0.8-0.9,0-2.2-1.1-2c-77.3,10.7-139.1,8.1-164.1,7.2c-11.6-0.4-15.5,0.8-15,2.6   l-0.1,0c0.3,2,2.7,20.9,2.5,36.4c-2.1,0.1-7.6,0.3-13.7,0.4c0-0.3,0-0.6,0.1-1l4.9-19.3c0.6-2.4-1.1-4.8-3.6-4.9l-19.9-1.3   c-2-0.1-3.6-1.7-3.7-3.7l-1.3-19.9c-0.2-2.5-2.5-4.2-4.9-3.6l-19.3,4.9c-1.9,0.5-3.9-0.5-4.7-2.4l-7.4-18.6   c-0.9-2.3-3.7-3.2-5.8-1.9l-16.9,10.7c-1.7,1.1-3.9,0.7-5.2-0.8l-12.7-15.4c-1.6-1.9-4.5-1.9-6.1,0l-12.7,15.4   c-1.3,1.5-3.5,1.9-5.2,0.8l-16.9-10.7c-2.1-1.3-4.9-0.4-5.8,1.9l-7.4,18.6c-0.7,1.9-2.7,2.9-4.7,2.4l-19.3-4.9   c-2.4-0.6-4.8,1.1-4.9,3.6l-1.3,19.9c-0.1,2-1.7,3.6-3.7,3.7l-19.9,1.3c-2.5,0.2-4.2,2.5-3.6,4.9l4.9,19.3c0.1,0.4,0.1,0.8,0.1,1.2   c-4.7-0.2-9.6-0.5-11.2-0.6c-0.2-15.5,2.2-34.4,2.5-36.4l-0.1,0c0.5-1.8-3.4-3-15-2.6c-25,0.9-86.9,3.6-164.3-7.2   c-1.1-0.1-1.8,1.1-1,1.9l53.7,61.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.4,0.1   c-19.5,13.2-45.3,38-52.4,44.9c-0.8,0.8-0.3,2.1,0.7,2.2c37.1,5.8,74.2,7.8,99.4,8.2l0.1,0c-0.3,13.5,0.1,20.9,0.2,23.3l0.1,1.3   c0.4,1.9,4,3.9,12.3,6.2c17.3,4.8,50.2,7,74.9,7.8l-4.9,19c-0.6,2.4,1.1,4.8,3.6,4.9l19.9,1.3c2,0.1,3.6,1.7,3.7,3.7l1.3,19.9   c0.2,2.5,2.5,4.2,4.9,3.6l19.3-4.9c1.9-0.5,3.9,0.5,4.7,2.4l7.4,18.6c0.9,2.3,3.7,3.2,5.8,1.9l16.9-10.7c1.7-1.1,3.9-0.7,5.2,0.8   l12.7,15.4c1.6,1.9,4.5,1.9,6.1,0l12.7-15.4c1.3-1.5,3.5-1.9,5.2-0.8l16.9,10.7c2.1,1.3,4.9,0.4,5.8-1.9l7.4-18.6   c0.7-1.9,2.7-2.9,4.7-2.4l19.3,4.9c2.4,0.6,4.8-1.1,4.9-3.6l1.3-19.9c0.1-2,1.7-3.6,3.7-3.7l19.9-1.3c2.5-0.2,4.2-2.5,3.6-4.9   l-4.8-18.8c25.2-0.8,60-3.1,77.3-7.9c8.3-2.3,11.9-4.3,12.3-6.2l0.1-1.3C1242.6,1328.8,1243,1321.4,1242.8,1307.9L1242.8,1307.9z"
        />
        <path
          style={{
            fill: 'none',
          }}
          d="M1242.8,1307.9c25.1-0.4,62.1-2.4,99.1-8.1c1.2-0.2,1.7-1.7,0.8-2.6c-7.5-7.3-33-31.7-52.3-44.7   c0,0-0.1,0-0.1,0c0.1,0,0.2-0.1,0.2-0.1l53.6-61.1c0.8-0.9,0-2.2-1.1-2c-77.3,10.7-139.1,8.1-164.1,7.2c-11.6-0.4-15.5,0.8-15,2.6   l-0.1,0c0.3,2,2.7,20.9,2.5,36.4c-2.1,0.1-7.6,0.3-13.7,0.4c0-0.3,0-0.6,0.1-1l4.9-19.3c0.6-2.4-1.1-4.8-3.6-4.9l-19.9-1.3   c-2-0.1-3.6-1.7-3.7-3.7l-1.3-19.9c-0.2-2.5-2.5-4.2-4.9-3.6l-19.3,4.9c-1.9,0.5-3.9-0.5-4.7-2.4l-7.4-18.6   c-0.9-2.3-3.7-3.2-5.8-1.9l-16.9,10.7c-1.7,1.1-3.9,0.7-5.2-0.8l-12.7-15.4c-1.6-1.9-4.5-1.9-6.1,0l-12.7,15.4   c-1.3,1.5-3.5,1.9-5.2,0.8l-16.9-10.7c-2.1-1.3-4.9-0.4-5.8,1.9l-7.4,18.6c-0.7,1.9-2.7,2.9-4.7,2.4l-19.3-4.9   c-2.4-0.6-4.8,1.1-4.9,3.6l-1.3,19.9c-0.1,2-1.7,3.6-3.7,3.7l-19.9,1.3c-2.5,0.2-4.2,2.5-3.6,4.9l4.9,19.3c0.1,0.4,0.1,0.8,0.1,1.2   c-4.7-0.2-9.6-0.5-11.2-0.6c-0.2-15.5,2.2-34.4,2.5-36.4l-0.1,0c0.5-1.8-3.4-3-15-2.6c-25,0.9-86.9,3.6-164.3-7.2   c-1.1-0.1-1.8,1.1-1,1.9l53.7,61.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.4,0.1   c-19.5,13.2-45.3,38-52.4,44.9c-0.8,0.8-0.3,2.1,0.7,2.2c37.1,5.8,74.2,7.8,99.4,8.2l0.1,0c-0.3,13.5,0.1,20.9,0.2,23.3l0.1,1.3   c0.4,1.9,4,3.9,12.3,6.2c17.3,4.8,50.2,7,74.9,7.8l-4.9,19c-0.6,2.4,1.1,4.8,3.6,4.9l19.9,1.3c2,0.1,3.6,1.7,3.7,3.7l1.3,19.9   c0.2,2.5,2.5,4.2,4.9,3.6l19.3-4.9c1.9-0.5,3.9,0.5,4.7,2.4l7.4,18.6c0.9,2.3,3.7,3.2,5.8,1.9l16.9-10.7c1.7-1.1,3.9-0.7,5.2,0.8   l12.7,15.4c1.6,1.9,4.5,1.9,6.1,0l12.7-15.4c1.3-1.5,3.5-1.9,5.2-0.8l16.9,10.7c2.1,1.3,4.9,0.4,5.8-1.9l7.4-18.6   c0.7-1.9,2.7-2.9,4.7-2.4l19.3,4.9c2.4,0.6,4.8-1.1,4.9-3.6l1.3-19.9c0.1-2,1.7-3.6,3.7-3.7l19.9-1.3c2.5-0.2,4.2-2.5,3.6-4.9   l-4.8-18.8c25.2-0.8,60-3.1,77.3-7.9c8.3-2.3,11.9-4.3,12.3-6.2l0.1-1.3C1242.6,1328.8,1243,1321.4,1242.8,1307.9L1242.8,1307.9z"
        />
        <g>
          <path
            style={{
              fill: 'none',
            }}
            d="M860.9,1256.4c-0.1,0.8-0.1,1.6-0.2,2.5c0.1-1,0.2-2.1,0.3-3c-1.1,0-2.2,0-3.2,0c0.9,0,1.7,0,2.6,0    C860.7,1255.8,861,1256.1,860.9,1256.4z"
          />
          <path
            style={{
              opacity: 0.05,
              fill: '#241F20',
            }}
            d="M922,1196.4c-25,0.9-86.9,3.6-164.3-7.2c-1.1-0.1-1.8,1.1-1,1.9l53.7,61.3    c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.2,0,0.4,0.1,0.6,0.1c0.1,0,0.3,0,0.4,0.1    c0.3,0,0.5,0.1,0.8,0.1c0.4,0,0.8,0.1,1.2,0.2c0.1,0,0.3,0,0.4,0.1c0.5,0.1,1.1,0.1,1.6,0.2c0.1,0,0.3,0,0.4,0    c0.6,0.1,1.3,0.1,2,0.2c0.1,0,0.2,0,0.4,0c0.4,0,0.9,0.1,1.4,0.1c1.2,0.1,2.5,0.2,3.9,0.4c0.2,0,0.3,0,0.5,0    c0.3,0,0.7,0.1,1.1,0.1c0.8,0.1,1.5,0.1,2.3,0.2c0.3,0,0.7,0.1,1,0.1c0.9,0.1,1.7,0.1,2.7,0.2c0.4,0,0.9,0.1,1.3,0.1    c0.9,0.1,1.7,0.1,2.7,0.2c0.5,0,1.1,0.1,1.7,0.1c0.9,0,1.7,0.1,2.6,0.1c0.7,0,1.4,0.1,2.1,0.1c0.8,0,1.6,0.1,2.5,0.1    c0.8,0,1.6,0.1,2.4,0.1c0.8,0,1.7,0.1,2.5,0.1c0.8,0,1.6,0,2.3,0.1c0.9,0,1.9,0.1,2.8,0.1c0.8,0,1.6,0,2.4,0c1.1,0,2.1,0,3.2,0    l0,0c1.6-16.8,3.4-26.7,4.3-31.2l0.6-2.5l0.1-0.5c0.5-2.9,8.5-5.3,19-7.4c9.9-2,24.8-5.4,34.3-7.6c8.8-1.9,17.1-5.3,17.8-7.6    C937.5,1197.2,933.6,1196,922,1196.4z"
          />
          <path
            style={{
              opacity: 0.25,
              fill: '#FFFFFF',
            }}
            d="M860.4,1255.8c-0.9,0-1.8,0-2.6,0c-0.8,0-1.7,0-2.4,0c-1,0-1.9,0-2.8-0.1    c-0.8,0-1.6,0-2.3-0.1c-0.9,0-1.7-0.1-2.5-0.1c-0.8,0-1.6-0.1-2.4-0.1c-0.9,0-1.7-0.1-2.5-0.1c-0.7,0-1.4-0.1-2.1-0.1    c-0.9,0-1.7-0.1-2.6-0.1c-0.6,0-1.1-0.1-1.7-0.1c-0.9-0.1-1.8-0.1-2.7-0.2c-0.4,0-0.9-0.1-1.3-0.1c-0.9-0.1-1.8-0.1-2.7-0.2    c-0.3,0-0.7-0.1-1-0.1c-0.8-0.1-1.6-0.1-2.3-0.2c-0.4,0-0.7-0.1-1.1-0.1c-0.2,0-0.3,0-0.5,0c-1.4-0.1-2.7-0.3-3.9-0.4    c-0.5,0-1-0.1-1.4-0.1c-0.1,0-0.2,0-0.4,0c-0.7-0.1-1.4-0.1-2-0.2c-0.2,0-0.3,0-0.4,0c-0.6-0.1-1.1-0.1-1.6-0.2    c-0.2,0-0.3,0-0.4-0.1c-0.4-0.1-0.9-0.1-1.2-0.2c-0.3,0-0.6-0.1-0.8-0.1c-0.1,0-0.3,0-0.4-0.1c-0.2,0-0.4-0.1-0.6-0.1    c-0.1,0-0.3,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.4,0.1c-19.5,13.2-45.3,38-52.4,44.9    c-0.8,0.8-0.3,2.1,0.7,2.2c37.1,5.8,74.2,7.8,99.4,8.2l0.1,0c0.2-7.7,0.5-17.5,1.2-29.3c0.1-0.8,0.1-1.7,0.2-2.6    c0.1-1.9,0.2-3.7,0.4-5.4c0-0.6,0.1-1.2,0.1-1.8c0.1-1.1,0.2-2.2,0.2-3.3c0-0.6,0.1-1.1,0.1-1.7c0.1-1,0.2-2.1,0.2-3.1    c0-0.6,0.1-1.1,0.1-1.7c0.1-0.8,0.1-1.7,0.2-2.5C861,1256.1,860.7,1255.8,860.4,1255.8z"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M832.4,1254.7c0.4,0,0.9,0.1,1.3,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M832.4,1254.7c0.4,0,0.9,0.1,1.3,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M832.4,1254.7c0.4,0,0.9,0.1,1.3,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M832.4,1254.7c0.4,0,0.9,0.1,1.3,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M825.4,1254.2c0.3,0,0.7,0.1,1.1,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M825.4,1254.2c0.3,0,0.7,0.1,1.1,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M825.4,1254.2c0.3,0,0.7,0.1,1.1,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M825.4,1254.2c0.3,0,0.7,0.1,1.1,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M850.1,1255.6c0.8,0,1.6,0,2.3,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M850.1,1255.6c0.8,0,1.6,0,2.3,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M850.1,1255.6c0.8,0,1.6,0,2.3,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M850.1,1255.6c0.8,0,1.6,0,2.3,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M828.8,1254.4c0.3,0,0.7,0.1,1,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M828.8,1254.4c0.3,0,0.7,0.1,1,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M828.8,1254.4c0.3,0,0.7,0.1,1,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M828.8,1254.4c0.3,0,0.7,0.1,1,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M821,1253.7    c1.2,0.1,2.5,0.2,3.9,0.4"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M821,1253.7    c1.2,0.1,2.5,0.2,3.9,0.4"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M821,1253.7    c1.2,0.1,2.5,0.2,3.9,0.4"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M821,1253.7    c1.2,0.1,2.5,0.2,3.9,0.4"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M819.2,1253.6c0.1,0,0.2,0,0.4,0"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M819.2,1253.6c0.1,0,0.2,0,0.4,0"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M819.2,1253.6c0.1,0,0.2,0,0.4,0"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M819.2,1253.6c0.1,0,0.2,0,0.4,0"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M840.7,1255.2c0.7,0,1.4,0.1,2.1,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M840.7,1255.2c0.7,0,1.4,0.1,2.1,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M840.7,1255.2c0.7,0,1.4,0.1,2.1,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M840.7,1255.2c0.7,0,1.4,0.1,2.1,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M855.3,1255.7c0.8,0,1.6,0,2.4,0"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M855.3,1255.7c0.8,0,1.6,0,2.4,0"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M855.3,1255.7c0.8,0,1.6,0,2.4,0"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M855.3,1255.7c0.8,0,1.6,0,2.4,0"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M845.3,1255.4c0.8,0,1.6,0.1,2.4,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M845.3,1255.4c0.8,0,1.6,0.1,2.4,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M845.3,1255.4c0.8,0,1.6,0.1,2.4,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M845.3,1255.4c0.8,0,1.6,0.1,2.4,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M836.4,1255    c0.5,0,1.1,0.1,1.7,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M836.4,1255    c0.5,0,1.1,0.1,1.7,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M836.4,1255    c0.5,0,1.1,0.1,1.7,0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M836.4,1255    c0.5,0,1.1,0.1,1.7,0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: '#241F20',
            }}
            d="M934.6,1235.4c-20.6-1-41.7-3-56.3-7c-8.3-2.3-11.9-4.3-12.3-6.2l-0.1,0l-0.6,2.5    c-0.9,4.5-2.7,14.4-4.3,31.2l0,0c-0.1,1-0.2,2-0.3,3c0,0.6-0.1,1.1-0.1,1.7c-0.1,1-0.2,2-0.2,3.1c0,0.6-0.1,1.1-0.1,1.7    c-0.1,1.1-0.2,2.2-0.2,3.3c0,0.6-0.1,1.2-0.1,1.8c-0.1,1.8-0.2,3.6-0.4,5.4c0,0.9-0.1,1.7-0.2,2.6l0.1,0    c14.5,5.9,35.6,9.2,56.8,11c0.2-0.8,0.5-1.6,1.2-2.2l15.4-12.7c1.5-1.3,1.9-3.5,0.8-5.2l-10.7-16.9c-1.3-2.1-0.4-4.9,1.9-5.8    l18.6-7.4c1.5-0.6,2.4-2,2.5-3.5C941.2,1235.7,936.2,1235.4,934.6,1235.4z"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M860,1268.7    c0,0.6-0.1,1.2-0.1,1.8"
          />
          <path
            style={{
              opacity: 0.05,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860,1268.7c0,0.6-0.1,1.2-0.1,1.8"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M860,1268.7    c0,0.6-0.1,1.2-0.1,1.8"
          />
          <path
            style={{
              opacity: 0.05,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860,1268.7c0,0.6-0.1,1.2-0.1,1.8"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.3,1263.7c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.05,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.3,1263.7c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.3,1263.7c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.05,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.3,1263.7c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.7,1258.9c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.05,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.7,1258.9c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.7,1258.9c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.05,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M860.7,1258.9c0,0.6-0.1,1.1-0.1,1.7"
          />
          <path
            style={{
              opacity: 0.45,
              fill: '#241F20',
            }}
            d="M937.1,1199L937.1,1199c-0.7,2.3-9.1,5.7-17.8,7.6c-9.5,2.1-24.4,5.6-34.3,7.6    c-10.4,2.1-18.5,4.5-19,7.4l-0.1,0.5l0.1,0c0.4,1.9,4,3.9,12.3,6.2c14.6,4,35.7,6,56.3,7C934.4,1219.9,936.8,1200.9,937.1,1199z"
          />
          <path
            style={{
              opacity: 0.1,
              fill: '#FFFFFF',
            }}
            d="M943.4,1341.4l-18.6-7.4c-2.3-0.9-3.2-3.7-1.9-5.8l10.7-16.9c1.1-1.7,0.7-3.9-0.8-5.2    l-15.4-12.7c-1.2-1-1.6-2.5-1.2-3.9c-21.2-1.8-42.3-5.1-56.8-11l-0.1,0c-0.7,11.9-1,21.6-1.2,29.3c-0.3,13.5,0.1,20.9,0.2,23.3    l0.1,1.3c0.4,1.9,4,3.9,12.3,6.2c17.3,4.8,50.2,7,74.9,7.8l0.1-0.4C946.2,1344.1,945.2,1342.1,943.4,1341.4z"
          />
          <path
            style={{
              opacity: 0.05,
              fill: '#241F20',
            }}
            d="M1342.9,1189.2c-77.3,10.7-139.1,8.1-164.1,7.2c-11.6-0.4-15.5,0.8-15,2.6    c0.7,2.3,9,5.7,17.8,7.6c9.5,2.1,24.4,5.6,34.3,7.6c10.4,2.1,18.5,4.5,19,7.4l0.1,0.5l0.6,2.5c0.9,4.5,2.7,14.4,4.3,31.2l0,0    c1.9,0,3.8,0,5.6-0.1c0.6,0,1.2,0,1.8,0c1.2,0,2.4-0.1,3.6-0.1c0.7,0,1.4,0,2-0.1c1,0,2-0.1,3-0.1c0.7,0,1.4-0.1,2.1-0.1    c0.9,0,1.8-0.1,2.6-0.1c0.7,0,1.4-0.1,2.1-0.1c0.8,0,1.6-0.1,2.4-0.1c0.7,0,1.3-0.1,1.9-0.1c0.7,0,1.5-0.1,2.2-0.1    c0.6,0,1.2-0.1,1.8-0.1c0.7-0.1,1.3-0.1,2-0.2c0.6,0,1.1-0.1,1.6-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.5,0,1-0.1,1.5-0.1    c0.5-0.1,1.1-0.1,1.6-0.2c0.4,0,0.9-0.1,1.3-0.1c0.5-0.1,1-0.1,1.4-0.2c0.4,0,0.8-0.1,1.1-0.1c0.4,0,0.8-0.1,1.2-0.1    c0.3,0,0.7-0.1,1-0.1c0.3,0,0.7-0.1,1-0.1c0.3,0,0.5-0.1,0.8-0.1c0.3,0,0.6-0.1,0.9-0.1c0.2,0,0.4-0.1,0.5-0.1    c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.3,0,0.5-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.1l53.6-61.1    C1344.7,1190.4,1344,1189.1,1342.9,1189.2z"
          />
          <path
            style={{
              opacity: 0.25,
              fill: '#FFFFFF',
            }}
            d="M1342.6,1297.2c-7.5-7.3-33-31.7-52.3-44.7c0,0-0.1,0-0.1,0c0,0,0,0,0,0    c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.5,0.1c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.4,0-0.5,0.1    c-0.3,0-0.6,0.1-0.9,0.1c-0.2,0-0.5,0.1-0.8,0.1c-0.3,0-0.6,0.1-1,0.1c-0.3,0-0.6,0.1-1,0.1c-0.4,0-0.8,0.1-1.2,0.1    c-0.4,0-0.7,0.1-1.1,0.1c-0.5,0.1-0.9,0.1-1.4,0.2c-0.4,0-0.8,0.1-1.3,0.1c-0.5,0.1-1.1,0.1-1.6,0.2c-0.5,0-1,0.1-1.5,0.1    c-0.6,0.1-1.2,0.1-1.8,0.2c-0.5,0-1.1,0.1-1.6,0.1c-0.6,0.1-1.3,0.1-2,0.2c-0.6,0-1.2,0.1-1.8,0.1c-0.7,0.1-1.4,0.1-2.2,0.1    c-0.6,0-1.3,0.1-1.9,0.1c-0.8,0-1.6,0.1-2.4,0.1c-0.7,0-1.3,0.1-2.1,0.1c-0.8,0-1.7,0.1-2.6,0.1c-0.7,0-1.4,0.1-2.1,0.1    c-1,0-2,0.1-3,0.1c-0.7,0-1.3,0.1-2,0.1c-1.2,0-2.4,0.1-3.6,0.1c-0.6,0-1.2,0-1.8,0c-1.8,0-3.7,0.1-5.6,0.1    c0.5,5.9,1,12.5,1.5,20.1c0,0.9,0.1,1.7,0.2,2.6c0.7,11.9,1,21.6,1.2,29.3l0.1,0c25.1-0.4,62.1-2.4,99.1-8.1    C1343,1299.6,1343.5,1298.1,1342.6,1297.2z"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1239.9,1255.8c1.9,0,3.8,0,5.6-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1239.9,1255.8c1.9,0,3.8,0,5.6-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1239.9,1255.8c1.9,0,3.8,0,5.6-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1239.9,1255.8c1.9,0,3.8,0,5.6-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1247.2,1255.7c1.2,0,2.4-0.1,3.6-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1247.2,1255.7c1.2,0,2.4-0.1,3.6-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1247.2,1255.7c1.2,0,2.4-0.1,3.6-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1247.2,1255.7c1.2,0,2.4-0.1,3.6-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1262.6,1255.1c0.8,0,1.6-0.1,2.4-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1262.6,1255.1c0.8,0,1.6-0.1,2.4-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1262.6,1255.1c0.8,0,1.6-0.1,2.4-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1262.6,1255.1c0.8,0,1.6-0.1,2.4-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1266.9,1254.8c0.7,0,1.5-0.1,2.2-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1266.9,1254.8c0.7,0,1.5-0.1,2.2-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1266.9,1254.8c0.7,0,1.5-0.1,2.2-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1266.9,1254.8c0.7,0,1.5-0.1,2.2-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1280.6,1253.7c0.5-0.1,1-0.1,1.4-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1280.6,1253.7c0.5-0.1,1-0.1,1.4-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1280.6,1253.7c0.5-0.1,1-0.1,1.4-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1280.6,1253.7c0.5-0.1,1-0.1,1.4-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1270.9,1254.5c0.7-0.1,1.3-0.1,2-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1270.9,1254.5c0.7-0.1,1.3-0.1,2-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1270.9,1254.5c0.7-0.1,1.3-0.1,2-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1270.9,1254.5c0.7-0.1,1.3-0.1,2-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M1277.7,1254    c0.6-0.1,1.1-0.1,1.6-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M1277.7,1254    c0.6-0.1,1.1-0.1,1.6-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M1277.7,1254    c0.6-0.1,1.1-0.1,1.6-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="M1277.7,1254    c0.6-0.1,1.1-0.1,1.6-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1274.5,1254.3c0.6-0.1,1.2-0.1,1.8-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1274.5,1254.3c0.6-0.1,1.2-0.1,1.8-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1274.5,1254.3c0.6-0.1,1.2-0.1,1.8-0.2"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1274.5,1254.3c0.6-0.1,1.2-0.1,1.8-0.2"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1283.2,1253.4c0.4,0,0.8-0.1,1.2-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1283.2,1253.4c0.4,0,0.8-0.1,1.2-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1283.2,1253.4c0.4,0,0.8-0.1,1.2-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1283.2,1253.4c0.4,0,0.8-0.1,1.2-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1252.8,1255.5c1,0,2-0.1,3-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1252.8,1255.5c1,0,2-0.1,3-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1252.8,1255.5c1,0,2-0.1,3-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1252.8,1255.5c1,0,2-0.1,3-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1257.9,1255.3c0.9,0,1.8-0.1,2.6-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1257.9,1255.3c0.9,0,1.8-0.1,2.6-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: 'none',
              stroke: '#241F20',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1257.9,1255.3c0.9,0,1.8-0.1,2.6-0.1"
          />
          <path
            style={{
              opacity: 0.25,
              fill: 'none',
              stroke: '#FFFFFF',
              strokeWidth: 0,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            d="    M1257.9,1255.3c0.9,0,1.8-0.1,2.6-0.1"
          />
          <path
            style={{
              opacity: 0.15,
              fill: '#241F20',
            }}
            d="M1241.4,1276c-0.5-7.6-1-14.3-1.5-20.1l0,0c-1.6-16.8-3.4-26.7-4.3-31.2l-0.6-2.5    l-0.1,0c-0.4,1.9-4,3.9-12.3,6.2c-14.6,4-35.7,6-56.3,7c-2.1,0.1-7.6,0.3-13.7,0.4c0,1.6,0.9,3.1,2.4,3.7l18.6,7.4    c2.3,0.9,3.2,3.7,1.9,5.8l-10.7,16.9c-1.1,1.7-0.7,3.9,0.8,5.2l15.4,12.7c0.8,0.6,1.1,1.5,1.3,2.4c22-1.7,44.2-5.1,59.2-11.2    l0.1,0C1241.5,1277.7,1241.4,1276.8,1241.4,1276z"
          />
          <path
            style={{
              opacity: 0.45,
              fill: '#241F20',
            }}
            d="M1234.8,1221.6c-0.5-2.9-8.5-5.3-19-7.4c-9.9-2-24.8-5.4-34.3-7.6    c-8.8-1.9-17.1-5.3-17.8-7.6l-0.1,0c0.3,2,2.7,20.9,2.5,36.4c20.6-1,41.7-3,56.3-7c8.3-2.3,11.9-4.3,12.3-6.2l0.1,0L1234.8,1221.6    z"
          />
          <path
            style={{
              opacity: 0.1,
              fill: '#FFFFFF',
            }}
            d="M1242.7,1307.9c-0.2-7.7-0.5-17.5-1.2-29.3l-0.1,0c-15.1,6.2-37.2,9.5-59.2,11.2    c0.2,1.3-0.1,2.8-1.3,3.7l-15.4,12.7c-1.5,1.3-1.9,3.5-0.8,5.2l10.7,16.9c1.3,2.1,0.4,4.9-1.9,5.8l-18.6,7.4    c-1.8,0.7-2.9,2.7-2.4,4.7l0.1,0.5c25.2-0.8,60-3.1,77.3-7.9c8.3-2.3,11.9-4.3,12.3-6.2l0.1-1.3    C1242.6,1328.8,1243,1321.4,1242.7,1307.9z"
          />
          <g>
            <circle
              style={{
                fill: 'none',
              }}
              cx={1049.8}
              cy={1289.4}
              r={103.3}
            />
          </g>
          <g>
            <circle
              style={{
                fill: 'none',
              }}
              cx={1049.8}
              cy={1289.4}
              r={82.8}
            />
          </g>
          <g>
            <polygon
              style={{
                fill: 'none',
              }}
              points="1084.2,1279.9 1101.1,1259.5 1075,1264 1079.5,1237.8 1059,1254.8 1049.8,1229.8      1040.6,1254.8 1020.2,1237.8 1024.7,1264 998.6,1259.5 1015.5,1279.9 990.6,1289.1 1015.5,1298.3 998.6,1318.7 1024.7,1314.2      1020.2,1340.4 1040.6,1323.4 1049.8,1348.3 1059,1323.4 1079.5,1340.4 1075,1314.2 1101.1,1318.7 1084.2,1298.3 1109.1,1289.1         "
            />
          </g>
        </g>
        <path
          style={{
            fill: 'none',
          }}
          d="M1342.9,1189.2c-77.3,10.7-139.1,8.1-164.1,7.2c-11.6-0.4-15.5,0.8-15,2.6l-0.1,0   c0.3,2,2.7,20.9,2.5,36.4c-2.1,0.1-7.6,0.3-13.7,0.4c0-0.3,0-0.6,0.1-1l4.9-19.3c0.6-2.4-1.1-4.8-3.6-4.9l-19.9-1.3   c-2-0.1-3.6-1.7-3.7-3.7l-1.3-19.9c-0.2-2.5-2.5-4.2-4.9-3.6l-19.3,4.9c-1.9,0.5-3.9-0.5-4.7-2.4l-7.4-18.6   c-0.9-2.3-3.7-3.2-5.8-1.9l-16.9,10.7c-1.7,1.1-3.9,0.7-5.2-0.8l-12.7-15.4c-1.6-1.9-4.5-1.9-6.1,0l-12.7,15.4   c-1.3,1.5-3.5,1.9-5.2,0.8l-16.9-10.7c-2.1-1.3-4.9-0.4-5.8,1.9l-7.4,18.6c-0.7,1.9-2.7,2.9-4.7,2.4l-19.3-4.9   c-2.4-0.6-4.8,1.1-4.9,3.6l-1.3,19.9c-0.1,2-1.7,3.6-3.7,3.7l-19.9,1.3c-2.5,0.2-4.2,2.5-3.6,4.9l4.9,19.3c0.1,0.4,0.1,0.8,0.1,1.2   c-4.7-0.2-9.6-0.5-11.2-0.6c-0.2-15.5,2.2-34.4,2.5-36.4l-0.1,0c0.5-1.8-3.4-3-15-2.6c-25,0.9-86.9,3.6-164.3-7.2   c-1.1-0.1-1.8,1.1-1,1.9l53.7,61.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.4,0.1   c-19.5,13.2-45.3,38-52.4,44.9c-0.8,0.8-0.3,2.1,0.7,2.2c37.1,5.8,74.2,7.8,99.4,8.2l0.1,0c-0.3,13.5,0.1,20.9,0.2,23.3l0.1,1.3   c0.4,1.9,4,3.9,12.3,6.2c17.3,4.8,50.2,7,74.9,7.8l-4.9,19c-0.6,2.4,1.1,4.8,3.6,4.9l19.9,1.3c2,0.1,3.6,1.7,3.7,3.7l1.3,19.9   c0.2,2.5,2.5,4.2,4.9,3.6l19.3-4.9c1.9-0.5,3.9,0.5,4.7,2.4l7.4,18.6c0.9,2.3,3.7,3.2,5.8,1.9l16.9-10.7c1.7-1.1,3.9-0.7,5.2,0.8   l12.7,15.4c1.6,1.9,4.5,1.9,6.1,0l12.7-15.4c1.3-1.5,3.5-1.9,5.2-0.8l16.9,10.7c2.1,1.3,4.9,0.4,5.8-1.9l7.4-18.6   c0.7-1.9,2.7-2.9,4.7-2.4l19.3,4.9c2.4,0.6,4.8-1.1,4.9-3.6l1.3-19.9c0.1-2,1.7-3.6,3.7-3.7l19.9-1.3c2.5-0.2,4.2-2.5,3.6-4.9   l-4.8-18.8c25.2-0.8,60-3.1,77.3-7.9c8.3-2.3,11.9-4.3,12.3-6.2l0.1-1.3c0.1-2.4,0.5-9.8,0.2-23.3l0.1,0   c25.1-0.4,62.1-2.4,99.1-8.1c1.2-0.2,1.7-1.7,0.8-2.6c-7.5-7.3-33-31.7-52.3-44.7c0,0-0.1,0-0.1,0c0.1,0,0.2-0.1,0.2-0.1l53.6-61.1   C1344.7,1190.4,1344,1189.1,1342.9,1189.2z"
        />
        <polygon
          style={{
            fill: '#241F20',
          }}
          points="1957.8,1335.7 1269.1,1335.7 1269.1,1333.6 1955.7,1333.6 1955.7,138 128.3,138    128.3,1333.6 830.5,1333.6 830.5,1335.7 126.2,1335.7 126.2,135.9 1957.8,135.9  "
        />
        <g>
          <path
            style={{
              fill: '#241F20',
            }}
            d="M479.6,498c5.4-9.8,12.9-17.4,22.6-22.8c9.6-5.4,20.6-8.2,32.8-8.2c15,0,27.8,4,38.5,11.9    c10.7,7.9,17.8,18.7,21.4,32.3H561c-2.5-5.3-6.1-9.3-10.7-12c-4.6-2.8-9.9-4.1-15.7-4.1c-9.5,0-17.1,3.3-23,9.9    c-5.9,6.6-8.8,15.4-8.8,26.4c0,11,2.9,19.8,8.8,26.4c5.9,6.6,13.5,9.9,23,9.9c5.9,0,11.1-1.4,15.7-4.1c4.6-2.8,8.2-6.8,10.7-12    h33.8c-3.6,13.7-10.7,24.4-21.4,32.3c-10.7,7.8-23.5,11.8-38.5,11.8c-12.2,0-23.2-2.7-32.8-8.2c-9.6-5.4-17.2-13-22.6-22.7    c-5.4-9.7-8.1-20.8-8.1-33.2C471.5,518.9,474.2,507.8,479.6,498z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M649.5,493.1v25.5h41.1l0,23.7h-41.1V570h46.5v24.6h-77.3l0-126.1h77.3v24.6H649.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M785.6,594.6L759.3,547H752v47.6h-30.7l0-126.1h51.6c9.9,0,18.4,1.7,25.4,5.2    c7,3.5,12.2,8.2,15.7,14.3c3.5,6.1,5.2,12.8,5.2,20.2c0,8.4-2.4,15.9-7.1,22.5c-4.7,6.6-11.7,11.3-20.9,14l29.1,50H785.6z     M752,525.2h19c5.6,0,9.9-1.4,12.7-4.1c2.8-2.8,4.2-6.7,4.2-11.7c0-4.8-1.4-8.6-4.2-11.3c-2.8-2.8-7-4.1-12.7-4.1h-19V525.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M927.2,468.5v24.6h-33.4l0,101.5H863l0-101.5h-33.4v-24.6H927.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M982.2,468.5l0,126.1h-30.7l0-126.1H982.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1091.8,468.5v24.6h-51.4v26.6h38.5l0,23.9h-38.5v51h-30.7l0-126.1H1091.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1140.3,468.5l0,126.1h-30.7l0-126.1H1140.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1167.1,498c5.4-9.8,12.9-17.4,22.6-22.8c9.6-5.4,20.6-8.2,32.8-8.2c15,0,27.8,4,38.5,11.9    c10.7,7.9,17.8,18.7,21.4,32.3h-33.8c-2.5-5.3-6.1-9.3-10.7-12c-4.6-2.8-9.9-4.1-15.7-4.1c-9.5,0-17.1,3.3-23,9.9    c-5.9,6.6-8.8,15.4-8.8,26.4c0,11,2.9,19.8,8.8,26.4c5.9,6.6,13.5,9.9,23,9.9c5.9,0,11.1-1.4,15.7-4.1c4.6-2.8,8.2-6.8,10.7-12    h33.8c-3.6,13.7-10.7,24.4-21.4,32.3c-10.7,7.8-23.5,11.8-38.5,11.8c-12.2,0-23.2-2.7-32.8-8.2c-9.6-5.4-17.2-13-22.6-22.7    c-5.4-9.7-8.1-20.8-8.1-33.2C1159,518.9,1161.7,507.8,1167.1,498z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1377.7,572.3h-47.1l-7.5,22.3h-32.2l45.6-126.1h35.6l45.6,126.1h-32.5L1377.7,572.3z     M1369.8,548.6l-15.6-46.2l-15.5,46.2H1369.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1509.6,468.5v24.6h-33.4l0,101.5h-30.7l0-101.5H1412v-24.6H1509.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1561,493.1v25.5h41.1l0,23.7H1561V570h46.5v24.6h-77.3l0-126.1h77.3v24.6H1561z"
          />
        </g>
        <g>
          <path
            style={{
              fill: '#241F20',
            }}
            d="M748.9,711.2c-2.9-1.6-5.2-3.9-6.9-6.9c-1.7-3-2.5-6.3-2.5-10c0-3.7,0.8-7,2.5-10    c1.7-3,4-5.3,6.9-6.9c2.9-1.6,6.1-2.5,9.6-2.5c3.5,0,6.8,0.8,9.7,2.5c2.9,1.6,5.2,3.9,6.8,6.9c1.7,2.9,2.5,6.3,2.5,10    c0,3.7-0.8,7.1-2.5,10c-1.7,2.9-3.9,5.2-6.8,6.9c-2.9,1.6-6.1,2.5-9.7,2.5C755,713.6,751.8,712.8,748.9,711.2z M765.7,707.5    c2.1-1.2,3.8-3,5-5.3c1.2-2.3,1.8-4.9,1.8-7.9c0-3-0.6-5.7-1.8-8c-1.2-2.3-2.9-4-5-5.2c-2.1-1.2-4.5-1.8-7.2-1.8    c-2.7,0-5.1,0.6-7.2,1.8c-2.1,1.2-3.8,3-5,5.2c-1.2,2.3-1.8,4.9-1.8,8c0,3,0.6,5.7,1.8,7.9c1.2,2.3,2.9,4,5,5.3s4.5,1.8,7.1,1.8    C761.2,709.3,763.6,708.7,765.7,707.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M807.6,675.4v4h-16.5v12.8h13.4v4h-13.4v17.1h-4.9v-37.9H807.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M854.9,704.8h-16.5l-3,8.4h-5.2l13.7-37.6h5.7l13.6,37.6h-5.2L854.9,704.8z M853.4,700.8l-6.8-19.1    l-6.8,19.1H853.4z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M871.9,684.3c1.7-3,3.9-5.3,6.8-6.9c2.9-1.7,6.1-2.5,9.6-2.5c4.1,0,7.7,1,10.8,3    c3.1,2,5.3,4.8,6.7,8.5h-5.9c-1.1-2.3-2.6-4-4.5-5.3c-2-1.2-4.3-1.8-7.1-1.8c-2.6,0-5,0.6-7.1,1.8c-2.1,1.2-3.7,3-4.9,5.2    c-1.2,2.3-1.8,4.9-1.8,8c0,3,0.6,5.6,1.8,7.9c1.2,2.3,2.8,4,4.9,5.2c2.1,1.2,4.5,1.8,7.1,1.8c2.8,0,5.1-0.6,7.1-1.8    c2-1.2,3.5-3,4.5-5.2h5.9c-1.4,3.6-3.7,6.4-6.7,8.4c-3.1,2-6.7,3-10.8,3c-3.5,0-6.7-0.8-9.6-2.5c-2.9-1.6-5.2-3.9-6.8-6.9    c-1.7-2.9-2.5-6.2-2.5-9.9C869.4,690.6,870.2,687.3,871.9,684.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M916,684.3c1.7-3,3.9-5.3,6.8-6.9c2.9-1.7,6.1-2.5,9.6-2.5c4.1,0,7.7,1,10.8,3    c3.1,2,5.3,4.8,6.7,8.5h-5.9c-1.1-2.3-2.6-4-4.5-5.3c-2-1.2-4.3-1.8-7.1-1.8c-2.6,0-5,0.6-7.1,1.8c-2.1,1.2-3.7,3-4.9,5.2    c-1.2,2.3-1.8,4.9-1.8,8c0,3,0.6,5.6,1.8,7.9c1.2,2.3,2.8,4,4.9,5.2c2.1,1.2,4.5,1.8,7.1,1.8c2.8,0,5.1-0.6,7.1-1.8    c2-1.2,3.5-3,4.5-5.2h5.9c-1.4,3.6-3.7,6.4-6.7,8.4c-3.1,2-6.7,3-10.8,3c-3.5,0-6.7-0.8-9.6-2.5c-2.9-1.6-5.2-3.9-6.8-6.9    c-1.7-2.9-2.5-6.2-2.5-9.9C913.5,690.6,914.4,687.3,916,684.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M967,711.2c-2.9-1.6-5.2-3.9-6.9-6.9c-1.7-3-2.5-6.3-2.5-10c0-3.7,0.8-7,2.5-10    c1.7-3,4-5.3,6.9-6.9c2.9-1.6,6.1-2.5,9.6-2.5c3.5,0,6.8,0.8,9.7,2.5c2.9,1.6,5.2,3.9,6.8,6.9c1.7,2.9,2.5,6.3,2.5,10    c0,3.7-0.8,7.1-2.5,10c-1.7,2.9-3.9,5.2-6.8,6.9c-2.9,1.6-6.1,2.5-9.7,2.5C973.1,713.6,969.9,712.8,967,711.2z M983.8,707.5    c2.1-1.2,3.8-3,5-5.3c1.2-2.3,1.8-4.9,1.8-7.9c0-3-0.6-5.7-1.8-8c-1.2-2.3-2.9-4-5-5.2c-2.1-1.2-4.5-1.8-7.2-1.8    c-2.7,0-5.1,0.6-7.2,1.8c-2.1,1.2-3.8,3-5,5.2c-1.2,2.3-1.8,4.9-1.8,8c0,3,0.6,5.7,1.8,7.9c1.2,2.3,2.9,4,5,5.3s4.5,1.8,7.1,1.8    C979.3,709.3,981.7,708.7,983.8,707.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1042.8,675.7v37.6h-4.9v-28l-12.5,28h-3.5l-12.5-28.1v28.1h-4.9v-37.6h5.3l13.9,31.1l13.9-31.1    H1042.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1075.4,694.3c-2.2,2.1-5.4,3.1-9.9,3.1h-7.3v15.8h-4.9v-37.9h12.2c4.3,0,7.5,1,9.8,3.1    c2.2,2.1,3.3,4.7,3.3,8C1078.6,689.6,1077.5,692.2,1075.4,694.3z M1071.6,691.6c1.3-1.2,2-2.9,2-5.1c0-4.7-2.7-7-8-7h-7.3v13.9    h7.3C1068.3,693.4,1070.3,692.8,1071.6,691.6z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1091.9,709.2h13.3v4h-18.2v-37.9h4.9V709.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1117.5,675.4v37.9h-4.9v-37.9H1117.5z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1133.4,712.3c-2-0.9-3.5-2.1-4.6-3.7c-1.1-1.6-1.7-3.4-1.7-5.5h5.3c0.2,1.8,0.9,3.3,2.2,4.5    c1.3,1.2,3.2,1.8,5.6,1.8c2.4,0,4.2-0.6,5.6-1.8c1.4-1.2,2-2.7,2-4.5c0-1.4-0.4-2.6-1.2-3.5c-0.8-0.9-1.8-1.6-3-2.1    c-1.2-0.5-2.8-1-4.8-1.5c-2.5-0.7-4.5-1.3-6-2c-1.5-0.7-2.8-1.7-3.9-3.1c-1.1-1.4-1.6-3.3-1.6-5.6c0-2.1,0.5-3.9,1.6-5.5    c1.1-1.6,2.5-2.8,4.4-3.7c1.9-0.9,4.1-1.3,6.5-1.3c3.5,0,6.5,0.9,8.7,2.7c2.3,1.8,3.5,4.1,3.8,7.1h-5.4c-0.2-1.4-0.9-2.7-2.3-3.8    c-1.3-1.1-3.1-1.7-5.3-1.7c-2.1,0-3.8,0.5-5.1,1.6c-1.3,1.1-2,2.6-2,4.5c0,1.4,0.4,2.5,1.2,3.4c0.8,0.9,1.7,1.5,2.9,2    c1.1,0.5,2.7,1,4.8,1.5c2.5,0.7,4.5,1.4,6,2c1.5,0.7,2.8,1.7,3.9,3.1c1.1,1.4,1.6,3.3,1.6,5.7c0,1.8-0.5,3.6-1.5,5.2    c-1,1.6-2.4,3-4.3,4c-1.9,1-4.2,1.5-6.8,1.5C1137.6,713.6,1135.4,713.2,1133.4,712.3z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1191.4,675.4v37.9h-4.9v-17.2h-19.3v17.2h-4.9v-37.9h4.9V692h19.3v-16.6H1191.4z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1240.4,675.7v37.6h-4.9v-28l-12.5,28h-3.5l-12.5-28.1v28.1h-4.9v-37.6h5.3l13.9,31.1l13.9-31.1    H1240.4z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1255.8,679.4v12.7h13.8v4.1h-13.8v13h15.4v4.1h-20.4v-37.9h20.4v4.1H1255.8z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1310.7,713.2h-4.9l-19.9-30.2v30.2h-4.9v-37.9h4.9l19.9,30.1v-30.1h4.9V713.2z"
          />
          <path
            style={{
              fill: '#241F20',
            }}
            d="M1344.6,675.4v4h-10.3v33.8h-4.9v-33.8H1319v-4H1344.6z"
          />
        </g>
        <path
          style={{
            fill: 'none',
          }}
          d="M1342.9,1189.2c-77.3,10.7-139.1,8.1-164.1,7.2c-11.6-0.4-15.5,0.8-15,2.6l-0.1,0   c0.3,2,2.7,20.9,2.5,36.4c-2.1,0.1-7.6,0.3-13.7,0.4c0-0.3,0-0.6,0.1-1l4.9-19.3c0.6-2.4-1.1-4.8-3.6-4.9l-19.9-1.3   c-2-0.1-3.6-1.7-3.7-3.7l-1.3-19.9c-0.2-2.5-2.5-4.2-4.9-3.6l-19.3,4.9c-1.9,0.5-3.9-0.5-4.7-2.4l-7.4-18.6   c-0.9-2.3-3.7-3.2-5.8-1.9l-16.9,10.7c-1.7,1.1-3.9,0.7-5.2-0.8l-12.7-15.4c-1.6-1.9-4.5-1.9-6.1,0l-12.7,15.4   c-1.3,1.5-3.5,1.9-5.2,0.8l-16.9-10.7c-2.1-1.3-4.9-0.4-5.8,1.9l-7.4,18.6c-0.7,1.9-2.7,2.9-4.7,2.4l-19.3-4.9   c-2.4-0.6-4.8,1.1-4.9,3.6l-1.3,19.9c-0.1,2-1.7,3.6-3.7,3.7l-19.9,1.3c-2.5,0.2-4.2,2.5-3.6,4.9l4.9,19.3c0.1,0.4,0.1,0.8,0.1,1.2   c-4.7-0.2-9.6-0.5-11.2-0.6c-0.2-15.5,2.2-34.4,2.5-36.4l-0.1,0c0.5-1.8-3.4-3-15-2.6c-25,0.9-86.9,3.6-164.3-7.2   c-1.1-0.1-1.8,1.1-1,1.9l53.7,61.3c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.4,0.1   c-19.5,13.2-45.3,38-52.4,44.9c-0.8,0.8-0.3,2.1,0.7,2.2c37.1,5.8,74.2,7.8,99.4,8.2l0.1,0c-0.3,13.5,0.1,20.9,0.2,23.3l0.1,1.3   c0.4,1.9,4,3.9,12.3,6.2c17.3,4.8,50.2,7,74.9,7.8l-4.9,19c-0.6,2.4,1.1,4.8,3.6,4.9l19.9,1.3c2,0.1,3.6,1.7,3.7,3.7l1.3,19.9   c0.2,2.5,2.5,4.2,4.9,3.6l19.3-4.9c1.9-0.5,3.9,0.5,4.7,2.4l7.4,18.6c0.9,2.3,3.7,3.2,5.8,1.9l16.9-10.7c1.7-1.1,3.9-0.7,5.2,0.8   l12.7,15.4c1.6,1.9,4.5,1.9,6.1,0l12.7-15.4c1.3-1.5,3.5-1.9,5.2-0.8l16.9,10.7c2.1,1.3,4.9,0.4,5.8-1.9l7.4-18.6   c0.7-1.9,2.7-2.9,4.7-2.4l19.3,4.9c2.4,0.6,4.8-1.1,4.9-3.6l1.3-19.9c0.1-2,1.7-3.6,3.7-3.7l19.9-1.3c2.5-0.2,4.2-2.5,3.6-4.9   l-4.8-18.8c25.2-0.8,60-3.1,77.3-7.9c8.3-2.3,11.9-4.3,12.3-6.2l0.1-1.3c0.1-2.4,0.5-9.8,0.2-23.3l0.1,0   c25.1-0.4,62.1-2.4,99.1-8.1c1.2-0.2,1.7-1.7,0.8-2.6c-7.5-7.3-33-31.7-52.3-44.7c0,0-0.1,0-0.1,0c0.1,0,0.2-0.1,0.2-0.1l53.6-61.1   C1344.7,1190.4,1344,1189.1,1342.9,1189.2z"
        />
        <polygon
          style={{
            opacity: 0.65,
            fill: '#FFFFFF',
          }}
          points="1084.2,1298.3 1109.1,1289.1 1084.2,1279.9 1101.1,1259.5 1075,1264    1079.5,1237.8 1059,1254.8 1049.8,1229.8 1040.6,1254.8 1020.2,1237.8 1024.7,1264 998.6,1259.5 1015.5,1279.9 990.6,1289.1    1015.5,1298.3 998.6,1318.7 1024.7,1314.2 1020.2,1340.4 1040.6,1323.4 1049.8,1348.3 1059,1323.4 1079.5,1340.4 1075,1314.2    1101.1,1318.7  "
        />
        <path
          style={{
            opacity: 0.35,
            fill: '#FFFFFF',
          }}
          d="M1049.8,1206.5c-45.7,0-82.8,37.1-82.8,82.8c0,45.7,37.1,82.8,82.8,82.8   c45.7,0,82.8-37.1,82.8-82.8C1132.6,1243.6,1095.6,1206.5,1049.8,1206.5z M1101.1,1318.7l-26.2-4.5l4.5,26.2l-20.4-17l-9.2,24.9   l-9.2-24.9l-20.4,17l4.5-26.2l-26.2,4.5l17-20.4l-24.9-9.2l24.9-9.2l-17-20.4l26.2,4.5l-4.5-26.2l20.4,17l9.2-24.9l9.2,24.9   l20.4-17l-4.5,26.2l26.2-4.5l-17,20.4l24.9,9.2l-24.9,9.2L1101.1,1318.7z"
        />
        <path
          style={{
            opacity: 0.1,
            fill: '#241F20',
          }}
          d="M1049.8,1186.1c-57,0-103.3,46.2-103.3,103.3c0,57,46.2,103.3,103.3,103.3   c57,0,103.3-46.2,103.3-103.3C1153.1,1232.3,1106.9,1186.1,1049.8,1186.1z M1049.8,1372.2c-45.7,0-82.8-37.1-82.8-82.8   c0-45.7,37.1-82.8,82.8-82.8c45.7,0,82.8,37.1,82.8,82.8C1132.6,1335.1,1095.6,1372.2,1049.8,1372.2z"
        />
        <path
          style={{
            opacity: 0.4,
            fill: '#241F20',
          }}
          d="M1180.9,1293.5c1.1-0.9,1.5-2.4,1.3-3.7c-0.2-0.9-0.5-1.8-1.3-2.4l-15.4-12.7   c-1.5-1.3-1.9-3.5-0.8-5.2l10.7-16.9c1.3-2.1,0.4-4.9-1.9-5.8l-18.6-7.4c-1.5-0.6-2.4-2.1-2.4-3.7c0-0.3,0-0.6,0.1-1l4.9-19.3   c0.6-2.4-1.1-4.8-3.6-4.9l-19.9-1.3c-2-0.1-3.6-1.7-3.7-3.7l-1.3-19.9c-0.2-2.5-2.5-4.2-4.9-3.6l-19.3,4.9   c-1.9,0.5-3.9-0.5-4.7-2.4l-7.4-18.6c-0.9-2.3-3.7-3.2-5.8-1.9l-16.9,10.7c-1.7,1.1-3.9,0.7-5.2-0.8l-12.7-15.4   c-1.6-1.9-4.5-1.9-6.1,0l-12.7,15.4c-1.3,1.5-3.5,1.9-5.2,0.8l-16.9-10.7c-2.1-1.3-4.9-0.4-5.8,1.9l-7.4,18.6   c-0.7,1.9-2.7,2.9-4.7,2.4l-19.3-4.9c-2.4-0.6-4.8,1.1-4.9,3.6l-1.3,19.9c-0.1,2-1.7,3.6-3.7,3.7l-19.9,1.3   c-2.5,0.2-4.2,2.5-3.6,4.9l4.9,19.3c0.1,0.4,0.1,0.8,0.1,1.2c-0.1,1.5-1,2.9-2.5,3.5l-18.6,7.4c-2.3,0.9-3.2,3.7-1.9,5.8l10.7,16.9   c1.1,1.7,0.7,3.9-0.8,5.2l-15.4,12.7c-0.7,0.6-1.1,1.4-1.2,2.2c-0.3,1.4,0,2.9,1.2,3.9l15.4,12.7c1.5,1.3,1.9,3.5,0.8,5.2   l-10.7,16.9c-1.3,2.1-0.4,4.9,1.9,5.8l18.6,7.4c1.8,0.7,2.9,2.7,2.4,4.7l-0.1,0.4l-4.9,19c-0.6,2.4,1.1,4.8,3.6,4.9l19.9,1.3   c2,0.1,3.6,1.7,3.7,3.7l1.3,19.9c0.2,2.5,2.5,4.2,4.9,3.6l19.3-4.9c1.9-0.5,3.9,0.5,4.7,2.4l7.4,18.6c0.9,2.3,3.7,3.2,5.8,1.9   l16.9-10.7c1.7-1.1,3.9-0.7,5.2,0.8l12.7,15.4c1.6,1.9,4.5,1.9,6.1,0l12.7-15.4c1.3-1.5,3.5-1.9,5.2-0.8l16.9,10.7   c2.1,1.3,4.9,0.4,5.8-1.9l7.4-18.6c0.7-1.9,2.7-2.9,4.7-2.4l19.3,4.9c2.4,0.6,4.8-1.1,4.9-3.6l1.3-19.9c0.1-2,1.7-3.6,3.7-3.7   l19.9-1.3c2.5-0.2,4.2-2.5,3.6-4.9l-4.8-18.8l-0.1-0.5c-0.5-1.9,0.5-3.9,2.4-4.7l18.6-7.4c2.3-0.9,3.2-3.7,1.9-5.8l-10.7-16.9   c-1.1-1.7-0.7-3.9,0.8-5.2L1180.9,1293.5z M1049.8,1392.6c-57,0-103.3-46.2-103.3-103.3c0-57,46.2-103.3,103.3-103.3   c57,0,103.3,46.2,103.3,103.3C1153.1,1346.4,1106.9,1392.6,1049.8,1392.6z"
        />
      </g>
      <g id="Course_Name">
        <g>
          <rect
            x={471}
            y={1108.1}
            style={{
              fill: '#231F20',
            }}
            width={1137.6}
            height={2.1}
          />
        </g>
      </g>
      <g id="Learner_Name">
        <g>
          <rect
            x={471}
            y={991.4}
            style={{
              fill: '#231F20',
            }}
            width={715.3}
            height={2.1}
          />
        </g>
      </g>
      <g id="Date">
        <rect
          x={1231.8}
          y={991.4}
          style={{
            fill: '#231F20',
          }}
          width={376.8}
          height={2.1}
        />
      </g>
    </svg>
  );
};
